"use client";
import React from "react";
import { Enquire, SecondaryBtn } from "../../../../components/molecules";
import Image from "next/image";
import { getImageUrlNew } from "../../../../lib/util";
import { useDisclosure } from "@nextui-org/react";
import dynamic from "next/dynamic";
import { useDictionary } from "../../../../context/dictionaryProvider";
const EnquireModal = dynamic(() =>
  import("../../../../components/modal/EnquireModal")
);

const BottomLeftRound = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="148"
      height="74"
      viewBox="0 0 192 96"
      fill="none"
      className="bottomLeftRound"
    >
      <path
        d="M154.839 80.8136C154.839 97.7143 179.908 95.6384 192 96L-1.52588e-05 96L-5.99858e-06 4.62802e-08C-6.91112e-06 9.46028 11.1995 15.0048 19.5111 17.4012C22.3903 18.2314 25.3968 18.4407 28.3933 18.4407L122.839 18.4407C140.512 18.4407 154.839 32.7675 154.839 50.4407L154.839 80.8136Z"
        fill="white"
      />
    </svg>
  );
};
const EnquireInsights = ({ data }) => {
  const dict = useDictionary();
  const { isOpen, onOpenChange } = useDisclosure();
  return (
    <>
      <Enquire className="mb-16">
        <div className="bg-[#FFDA73] overflow-hidden rounded-[16px] gap-0 items-start grid grid-cols-1 xl:grid-cols-[60%_1fr]">
          <div className="py-[45px] px-[63px]">
            <h3 className="text-[32px] font-extrabold leading-normal relative">
              {data?.title}
            </h3>
            <p className="mt-5 text-black text-sm leading-normal tracking-[0.48px] font-normal">
              {data?.description}
            </p>
          </div>
          <div className="relative h-[352px] max-h-full w-full overflow-hidden">
            {data?.attachment?.url ? (
              <Image
                loading="lazy"
                src={getImageUrlNew(data?.attachment, "small")}
                fill
                objectFit="cover"
                alt="Image"
                width=""
                height=""
              />
            ) : (
              <Image
                loading="lazy"
                src="https://d3v381xb6gm5e.cloudfront.net/media/13969942_de24873a03.png"
                fill
                objectFit="cover"
                alt="Placeholder"
                className="object-contain bg-[#0000001a] p-12 rounded-2xl h-full"
              />
            )}
          </div>
        </div>
        <SecondaryBtn
          type="button"
          className="absolute left-0 bottom-0 !px-[25px]"
          size="14px"
          onClick={(e) => {
            e.stopPropagation();
            onOpenChange();
          }}
        >
          {dict?.enquire}
        </SecondaryBtn>
        <BottomLeftRound />
      </Enquire>
      {isOpen && (
        <EnquireModal isOpen={isOpen} onOpenChange={onOpenChange} course={[]} />
      )}
    </>
  );
};

export default EnquireInsights;
